import React, { useState } from 'react';
import { FileTextIcon, HomeIcon, ClipboardListIcon, DownloadIcon, BookOpenIcon } from 'lucide-react';
export const ScenarioDetails = ({
  scenario,
  formatPrice,
  showVat
}) => {
  const [activeTab, setActiveTab] = useState('materialeliste');
  const getVatAdjustedPrice = price => {
    return showVat ? price : Math.round(price / 1.25);
  };
  const materialList = [{
    vvsNr: '46 2812.104',
    description: 'Roth gulvvarmefordeler 4 afgr. inkl. ophæng',
    quantity: 1,
    unitPrice: 3245,
    totalPrice: 3245
  }, {
    vvsNr: '46 2812.204',
    description: 'Roth shunt med termostatisk ventil',
    quantity: 1,
    unitPrice: 2890,
    totalPrice: 2890
  }, {
    vvsNr: '46 2812.304',
    description: 'Roth Touchline® SL, Master',
    quantity: 1,
    unitPrice: 4350,
    totalPrice: 4350
  }, {
    vvsNr: '46 2812.404',
    description: 'Roth X-PERT S5® 16 mm, 200m rulle',
    quantity: 4,
    unitPrice: 3125,
    totalPrice: 12500
  }, {
    vvsNr: '46 2812.504',
    description: 'Roth monteringsskinne 16mm, 1m',
    quantity: 25,
    unitPrice: 125,
    totalPrice: 3125
  }, {
    vvsNr: '46 2812.604',
    description: 'Roth vendebøjning 16mm',
    quantity: 8,
    unitPrice: 95,
    totalPrice: 760
  }, {
    vvsNr: '46 2812.704',
    description: 'Roth fordelerrørsbeslag',
    quantity: 2,
    unitPrice: 275,
    totalPrice: 550
  }];
  return <section className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-95">
      <div className="p-6" data-id="element-96">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-97">
          Detaljer for {scenario.name}
        </h2>
        <div className="border-b border-gray-200" data-id="element-98">
          <nav className="-mb-px flex space-x-8" data-id="element-99">
            <button className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'materialeliste' ? 'border-red-500 text-red-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('materialeliste')} data-id="element-100">
              <div className="flex items-center" data-id="element-101">
                <FileTextIcon className="mr-2 h-4 w-4" data-id="element-102" />
                Materialeliste
              </div>
            </button>
            <button className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'etager' ? 'border-red-500 text-red-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('etager')} data-id="element-103">
              <div className="flex items-center" data-id="element-104">
                <HomeIcon className="mr-2 h-4 w-4" data-id="element-105" />
                Etager & rum
              </div>
            </button>
            <button className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'dokumenter' ? 'border-red-500 text-red-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('dokumenter')} data-id="element-106">
              <div className="flex items-center" data-id="element-107">
                <ClipboardListIcon className="mr-2 h-4 w-4" data-id="element-108" />
                Skema & dokumenter
              </div>
            </button>
          </nav>
        </div>
        <div className="mt-6" data-id="element-109">
          {activeTab === 'materialeliste' && <div className="space-y-4" data-id="element-110">
              <div className="overflow-x-auto" data-id="element-111">
                <table className="min-w-full divide-y divide-gray-200" data-id="element-112">
                  <thead className="bg-gray-50" data-id="element-113">
                    <tr data-id="element-114">
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-115">
                        VVS-Nr.
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-116">
                        Beskrivelse
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-117">
                        Bestilt antal
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-118">
                        Stk. pris
                      </th>
                      <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-119">
                        Total pris
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-120">
                    <tr className="bg-gray-100" data-id="element-121">
                      <td colSpan={5} className="px-6 py-2 text-sm font-medium text-gray-900" data-id="element-122">
                        Storey 1 / Manifold 1 (softline)
                      </td>
                    </tr>
                    {materialList.map((item, index) => <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-123">
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-124">
                          {item.vvsNr}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-125">
                          {item.description}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-126">
                          {item.quantity}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-127">
                          {formatPrice(getVatAdjustedPrice(item.unitPrice))}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-128">
                          {formatPrice(getVatAdjustedPrice(item.totalPrice))}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 mt-4" data-id="element-129">
                <button className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none" data-id="element-130">
                  <DownloadIcon className="mr-2 h-4 w-4" data-id="element-131" />
                  Download materialeliste (PDF)
                </button>
                <button className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none" data-id="element-132">
                  <BookOpenIcon className="mr-2 h-4 w-4" data-id="element-133" />
                  Vis montagevejledning
                </button>
              </div>
            </div>}
          {activeTab === 'etager' && <div className="py-4 text-center text-gray-500" data-id="element-134">
              <HomeIcon className="h-12 w-12 mx-auto text-gray-400" data-id="element-135" />
              <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-136">
                Etage- og rumoversigt
              </h3>
              <p className="mt-1 text-sm text-gray-500" data-id="element-137">
                Detaljeret information om etager og rum vil blive vist her.
              </p>
            </div>}
          {activeTab === 'dokumenter' && <div className="py-4 text-center text-gray-500" data-id="element-138">
              <ClipboardListIcon className="h-12 w-12 mx-auto text-gray-400" data-id="element-139" />
              <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-140">
                Skemaer og dokumenter
              </h3>
              <p className="mt-1 text-sm text-gray-500" data-id="element-141">
                Tekniske dokumenter og skemaer vil blive vist her.
              </p>
            </div>}
        </div>
      </div>
    </section>;
};